import { Sparkles } from "lucide-react";
import { t } from "../lib/i18n";

/** Color band by score: ≥75 forest, 50-74 gold, <50 muted */
const scoreColor = (v) => (v >= 75 ? "text-forest" : v >= 50 ? "text-gold" : "text-muted-foreground");

export const MatchScore = ({ value, label = "Match IA", testid }) => (
  <div className="hairline px-3 py-2 bg-bone text-right flex-shrink-0" data-testid={testid}>
    <div className="font-mono-label text-muted-foreground flex items-center gap-1 justify-end" style={{ fontSize: "0.55rem" }}>
      <Sparkles className="w-2.5 h-2.5" /> {label}
    </div>
    <div className={`font-serif-display text-3xl leading-none ${scoreColor(value ?? 0)}`}>
      {value ?? "—"}
    </div>
  </div>
);

const DIM_LABELS = {
  sector: "Sector",
  geografia: t("Geografía"),
  ebitda: "EBITDA",
  facturacion: t("Facturación"),
  ticket: "Ticket",
};

export const BreakdownChips = ({ breakdown, max }) => {
  if (!breakdown) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {Object.entries(breakdown).map(([k, v]) => {
        const m = max[k] || 1;
        const full = v >= m;
        const zero = v === 0;
        return (
          <span
            key={k}
            data-testid={`match-dim-${k}`}
            className={`hairline px-2 py-1 font-mono-label ${
              full ? "bg-forest/10 text-forest border-forest/30"
              : zero ? "bg-secondary text-muted-foreground"
              : "bg-gold/10 text-[#A16207] border-gold/40"
            }`}
            style={{ fontSize: "0.6rem" }}
          >
            {DIM_LABELS[k] || k} {v}/{m}
          </span>
        );
      })}
    </div>
  );
};

export const SEARCHER_HARD_MAX = { sector: 30, geografia: 20, ebitda: 30, facturacion: 20 };
export const INVESTOR_HARD_MAX = { sector: 40, geografia: 30, ticket: 30 };
